export const toggleSidebarNav = {
  methods: {
    toggleSidebarNav() {
      this.isToggled = !this.isToggled;
    },
  },
};
